/* unplugin-vue-components disabled */import { render } from "./isMobile.vue?vue&type=template&id=764f16a6"
import script from "./isMobile.vue?vue&type=script&lang=js"
export * from "./isMobile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__